import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ProductModal, UpdateOrderModal } from "./Modal";
import { useNavigate, useParams } from "react-router";
import { Header, TopBar } from "../../components/Header";
import { Footer } from "../../components/Footer";
import { OrderApi } from "../../app/api/order.api";



export function Order()
{

  const navigate = useNavigate();
  const order = OrderApi(); 
  const { id } = useParams();

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showDetail, setShowDetail] = useState(false);

  const [selectedData, setSelectedData] = useState({});
  const [showModal, setShowModal] = useState(false);
  
       
  const handleEdit = ( product ) => {
    setSelectedProduct( product );
    setShowDetail(true);
  };
          
  const fetchData = async () => { 
    const {data} = await order.findOne(id);
    return data.data; 
  }
  const { isLoading, data=[], error, refetch } = useQuery({  queryKey: ["order"], queryFn: fetchData });

  const onClick = (orderId, orderRef, operationType) => { 
    setSelectedData({
      orderId : orderId,
      orderRef : orderRef,
      operationType : operationType,
    });
    setShowModal(true);
  }
        
  return(

    <div className='container-fluid bg-light-gray'>
      {/* _____________________SECTION HEADER EQUIPMENT ___________________ */} 
        
      <div className='row'> <TopBar /> </div>
      <div className='row sticky-top'> <Header page={6} /> </div>
                    
      {/* _____________________SECTION 1 ORDER ___________________ */} 
        
      {
        isLoading ? (
          <div className='row vh-100 align-items-center'>
            <div className="d-flex flex-column align-items-center gap-3">
              <div className="spinner-border text-green mb-3" style={{ width: '6rem', height: '6rem' }}></div>
              <p className="text-secondary"> Chargement en cours... </p>
            </div>
          </div>
          )  :  (
        <div className='row justify-content-center pt-4 pb-5 mb-3'>
          <div className='col-lg-9 col-md-11'>
                
            <div className='row mb-2 mt-4' >
              <div className="border bg-white text-secondary rounded-3">
                <div className="d-flex justify-content-between flex-column flex-md-row align-items-center border-bottom px-4 py-3 gap-2">
                  <span className="fs-5"> <i className="bi bi-receipt me-2"></i> Détail de la commande </span>
                  <div className="d-flex gap-3">
                    {
                      (data.status === "pending" ) && (
                        <button className='btn btn-sm btn-outline-danger px-3' onClick={() => onClick(data.id, data.ref, "cancel")}> 
                          <i className="bi bi-x-circle me-1"></i> Annuler la commande 
                        </button>
                      )
                    }
                    {
                      (data.status === "canceled" ) && (
                        <button className='btn btn-sm btn-outline-green px-3' onClick={() => onClick(data.id, data.ref, "restaure")}> 
                          Restaurer la commande <i className="bi bi-chevron-right ms-1"></i> 
                        </button>
                      )
                    }
                    {
                      (data.status === "delivered" ) && (
                        <div className='d-flex align-items-center py-1 px-3 bg-green text-white'> 
                          <i className="bi bi-check-circle me-1"></i>
                          <small className='small text-white'>  Commande livrée </small>
                        </div>
                      )
                    }
                    <button onClick={() => navigate(-1)} className='btn btn-sm btn-outline-dark px-3'> 
                        Retour <i className="bi bi-chevron-right ms-1"></i> 
                    </button>
                  </div>
                </div>  
                <div className="d-flex px-4 py-3 gap-2">
                   <span className='text-white px-2 bg-green py-1'> Ref :  </span> 
                   <span className='text-secondary bold px-3 border py-1'> { data?.ref } </span> 
                </div>
              </div> 
            </div>

            <div className='row mb-2' >
              <div className="bg-white rounded-3 mb-4 px-4 py-3 border">
                <div className="d-flex align-items-center">    
                  <span className="border text-secondary py-2 px-3 bg-light fw-bold border-end"> 
                    <i className="bi bi-grid-fill me-2"></i> Montant total :  
                  </span>
                   <span className="border text-secondary py-2 px-3 fw-bold"> { data?.amount } </span>
                   <span className="border text-secondary py-2 px-3 bg-light border-start"> FCFA  </span>
                </div>  
              </div> 
            </div>

            {/* Produits Commandés */}
            <div className='row border bg-white text-secondary rounded-3 p-4 mb-4'> 
            {            
              data.products.map((item, index) => (

                <div key={index} className='border d-flex flex-column flex-lg-row gap-3 mb-3'>
                  <div className='product-image p-3 bg-light'>
                    <img src={item.images[0].url} className="img-fluid-custom" alt={item.name} />
                  </div>
                  <div className='product-info border-start p-3 w-100'>
                    <div className='d-flex justify-content-between w-100 mb-2'>
                      <span className='text-secondary fw-bold'>{item.name}</span>
                      <button className='btn btn-sm btn-outline-green' onClick={() => handleEdit( item ) }> 
                        Ouvrir <i className="bi bi-box-arrow-up-right ms-1"></i>
                      </button>
                    </div>
                    <div className='d-flex justify-content-between w-100'>
                        <span className='label'>Prix unitaire : </span>
                        <span className='value'> { item.price + " " + item.currency} </span>
                    </div>
                    <div className='d-flex justify-content-between w-100 pb-2 border-bottom'>
                        <span className='label'>Quantité</span>
                        <span className='value'>{ item.OrderProduct.count } </span>
                    </div>
                    <div className='d-flex justify-content-between w-100 mt-2'>
                      <span className='text-dark'>Prix total</span>
                      <span className='h5 text-dark'>{ item.OrderProduct.totalPrice } FCFA</span>
                    </div>
                  </div>
                </div>
                ))
            }                
            {
              error && ( 
                 <div className="text-center p-4 border alert alert-danger w-100">
                   Une erreur est survenue. Vueiller vérifier votre connexion 
                 </div>
              )
            }
            </div>    

          </div>   
        </div>
        )
      }
        {/* _____________________SECTION FOOTER ORDER ___________________ */} 
            
        <div className='row'>
          <Footer />
        </div>
        

        {/* Modal de previsualisation */}
        {
          selectedProduct && ( <ProductModal show={showDetail} onHide={() => setShowDetail(false)} product={selectedProduct} /> )
        }

        {/* Modal de mise a jour de status d'une commande */}
        {
          showModal &&  ( <UpdateOrderModal show={showModal} onHide={() => setShowModal(false)} order={selectedData} refetch={refetch} /> )
        }
        

      </div>

    )
}